import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pn-quick-cta',
  styleUrl: 'pn-quick-cta.scss',
})
export class PnQuickCta {
  @Element() hostElement: HTMLElement;
  @Prop() heading: string = null;
  @Prop() preamble: string = null;

  render() {
    return (
      <Host>
        <div class="quick-cta__content">
          { this.heading && <h2 class="quick-cta__content__heading">{this.heading}</h2> }
          <p class="quick-cta__content__preamble">{this.preamble}</p>
          <slot name="quick-cta-cta"></slot>
        </div>
      </Host>
    );
  }
}
